import { Component, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InventoryContext } from '../../inventory-manager/inventory.context';
import { LotDetailContext } from './lot-detail.context';
import { FILE_MANAGER_URL, INVENTORY_DETAILS_URL } from '../../app.constants';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-files-pane',
    template: `
        <div class="container-fluid pt-3">
            <iframe width="100%" height="570" style="border: none;" [src]="url"></iframe>
        </div>`
})
export class FilesPaneComponent {
    readonly url: SafeResourceUrl;

    constructor(private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private context: InventoryContext,
                private lotDetailContext: LotDetailContext,
                private urlService: UrlService
    ) {
        const variableName = this.route.snapshot.queryParamMap.get('variableName');
        var urlStr = FILE_MANAGER_URL + '?restartApplication' +
            '&cropName=' + this.context.cropName +
            '&programUUID=' + this.context.programUUID;
        if (variableName) {
            urlStr += '&variableName=' + variableName;
        }
        urlStr += '&lotId=' + this.lotDetailContext.lotId + '&embedded=true' + '&modal';
        const safeUrl = this.urlService.buildSafeUrl(urlStr);
        this.url = urlStr !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }
}
